module.exports = __webpack_public_path__ + "static/media/th.76fca72f.svg";